import ApiService from '../common/api.service';

import {
  FETCH_DESCANSOS, ADD_DESCANSO, REMOVE_DESCANSO,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_DESCANSOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/descansos', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [ADD_DESCANSO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/agregar_descanso', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_DESCANSO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('rh/eliminar_descanso', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
